/* eslint-disable css-modules/no-unused-class */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// classnames
import classNames from 'classnames';
// jl-design-system
import Form from 'jl-design-system/components/form/Form';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';
import { QUANTITY_INPUT } from 'jl-design-system/form/fields';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
// lodash
import get from 'lodash/get';
import includes from 'lodash/includes';
import find from 'lodash/find';
// components
import EditBasketItemOverlay from '../edit-basket-item-overlay/EditBasketItemOverlay';
// config
import getItemQuantityFormConfig, { getFormId } from '../../utils/form/configs/itemQuantity';
// constants
import deliveryConstants from '../../constants/deliveryConstants';
import editBasketConstants from '../../constants/editBasketConstants';
// helpers
import { getSubtotalText } from '../order-item/OrderItemHelper';
import { shouldShowCollectionHelpText } from '../../utils/collection/collectionHelp';
// utils
import thumbnail from '../../utils/image/thumbnail';
import isItemFabric from '../../utils/orderform/isItemFabric';
// styles
import styles from './edit-basket-item.scss';


export class EditBasketItem extends PureComponent {

  static propTypes = {
    children: PropTypes.node,
    deliveries: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
    handleQuantityChange: PropTypes.func,
    handleRemoveItem: PropTypes.func,
    hideItemRemoveOverlay: PropTypes.func,
    isChildItem: PropTypes.bool,
    isItemUpdating: PropTypes.bool,
    isProcessing: PropTypes.bool,
    item: PropTypes.shape({
      id: PropTypes.string,
      imageUrl: PropTypes.string,
      name: PropTypes.string,
      partnerDiscount: PropTypes.string,
      priceHistory: PropTypes.shape({}),
      quantity: PropTypes.number,
      subtotal: PropTypes.string,
      subtotalDiscounted: PropTypes.string,
    }),
    lastItemInBasket: PropTypes.bool,
    maxValue: PropTypes.number,
    onFormSubmit: PropTypes.func,
    overlayType: PropTypes.oneOf([
      '',
      editBasketConstants.REMOVE_ITEM,
      editBasketConstants.OUT_OF_STOCK_ITEM,
    ]),
    partnerDiscountEnabled: PropTypes.bool,
    removeItemApiCallActive: PropTypes.bool,
    showCollectionHelp: PropTypes.bool,
    showItemRemoveOverlay: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    deliveries: [],
    disabled: false,
    handleQuantityChange: window.defaultFunc,
    handleRemoveItem: window.defaultFunc,
    hideItemRemoveOverlay: window.defaultFunc,
    isChildItem: false,
    isItemUpdating: false,
    isProcessing: false,
    item: {},
    lastItemInBasket: false,
    maxValue: 0,
    onFormSubmit: window.defaultFunc,
    overlayType: '',
    partnerDiscountEnabled: false,
    removeItemApiCallActive: false,
    showCollectionHelp: false,
    showItemRemoveOverlay: window.defaultFunc,
  };

  showItemRemoveOverlay = () => {
    const { item: { id }, showItemRemoveOverlay } = this.props;
    showItemRemoveOverlay(id);
  };

  onRemoveItemYes = () => {
    const { item: { id }, handleRemoveItem, lastItemInBasket, isChildItem } = this.props;
    handleRemoveItem(id, lastItemInBasket, isChildItem);
  };

  onRemoveItemNo = () => {
    const { item: { id }, hideItemRemoveOverlay } = this.props;
    hideItemRemoveOverlay(id);
  };

  render() {
    const {
      deliveries,
      isProcessing,
      disabled,
      item,
      maxValue,
      handleQuantityChange,
      partnerDiscountEnabled,
      onFormSubmit,
      children,
      isChildItem,
      overlayType,
      isItemUpdating,
      lastItemInBasket,
      removeItemApiCallActive,
      showCollectionHelp,
    } = this.props;

    const {
      id,
      imageUrl,
      name,
      partnerDiscount,
      quantity,
      subtotal,
      subtotalDiscounted,
      priceHistory: {
        reducedToClear,
        originalSubtotal,
      } = {},
    } = item;

    const delivery = find(deliveries, d => includes(d.itemIds, id));
    const isTradePlace = get(delivery, 'type', '') === deliveryConstants.TRADEPLACE;
    const noAmend = isTradePlace;
    const hasChildItems = React.Children.count(children) > 0;
    const renderImage = !!(imageUrl && !isChildItem);

    const formId = getFormId(id);
    const config = getItemQuantityFormConfig({
      item,
      changeHandler: handleQuantityChange(formId),
      isItemFabric: isItemFabric(item),
      maxValue,
      isTradePlace,
    });

    const itemDetailsContainerClassnames = classNames(styles.itemDetailsContainer, {
      [styles.fabricItem]: isItemFabric(item),
    });

    const formDisabled = disabled || noAmend || !!overlayType;
    const removeButtonDisabled = disabled || !!overlayType;
    const headingId = `order-item-name-${id}`;

    return (
      <div
        key={id}
        className={styles.itemContainer}
        data-test={isChildItem ? 'edit-basket-child-item' : 'edit-basket-item'}
      >

        <div className={styles.itemInnerContainer}>

          <div className={styles.itemImage}>
            {
              renderImage &&
              <img
                alt={name}
                aria-hidden="true"
                data-test="order-item-image"
                src={thumbnail(imageUrl)}
              />
            }
          </div>

          <div className={styles.itemInfoContainer} data-test="edit-basket-item-info">
            <p
              data-test="order-item-name"
              id={headingId}
            >
              {name}
            </p>

            {
              showCollectionHelp &&
              <p><strong>Collection unavailable</strong></p>
            }

            <div className={itemDetailsContainerClassnames} data-test="edit-basket-item-details">

              <Form
                config={config}
                data-test="edit-basket-item-form"
                disabled={formDisabled}
                enableReinitialize
                form={config.id}
                initialValues={{ [QUANTITY_INPUT.id]: (quantity && quantity.toString()), itemId: id }}
                onSubmit={onFormSubmit}
                useFormValidationErrorsAlertMessage={false}
              />

              <div className={styles.itemSubtotalContainer} data-test="edit-basket-item-subtotal-container">
                {
                  isItemUpdating &&
                  <LoadingSpinner className={styles.spinner} />
                }
                {
                  !isItemUpdating &&
                  <React.Fragment>
                    {
                      getSubtotalText(
                        partnerDiscount,
                        partnerDiscountEnabled,
                        false,
                        subtotal,
                        subtotalDiscounted,
                        styles,
                        reducedToClear,
                        originalSubtotal,
                        true,
                      )
                    }
                  </React.Fragment>
                }
              </div>
            </div>

            <UnderlinedButton
              aria-describedby={headingId}
              className={styles.removeButton}
              data-test="remove-item-button"
              disabled={removeButtonDisabled}
              onClick={this.showItemRemoveOverlay}
            >
              Remove
            </UnderlinedButton>

          </div>
        </div>

        {
          overlayType &&
          <EditBasketItemOverlay
            disabled={isProcessing}
            hasChildItems={hasChildItems}
            lastItemInBasket={lastItemInBasket}
            onRemoveNo={this.onRemoveItemNo}
            onRemoveYes={this.onRemoveItemYes}
            removeItemApiCallActive={removeItemApiCallActive}
            type={overlayType}
          />
        }

        {
          hasChildItems &&
          <div className={styles.childItemsContainer} data-test="edit-basket-item-children">
            {children}
          </div>
        }

      </div>
    );
  }
}

export default connect((state, ownProps) => ({
  showCollectionHelp: shouldShowCollectionHelpText({
    isChildItem: ownProps?.isChildItem,
    id: ownProps?.item.id,
    state,
  }),
}))(EditBasketItem);
